import React from "react";
import { Link } from "react-router-dom";
import LegalLayout from "../components/LegalLayout";
import { useT } from "../lib/i18n";

export default function Support() {
  const { t, lang } = useT();
  return (
    <LegalLayout title={t("settings.support")}>
      {lang === "en" ? (
        <>
          <h1>Support</h1>
          <p>We keep support simple during our public beta. If you need help:</p>
          <h2>Purchase issues</h2>
          <p>
            If you paid but do not see Full Access, use the{" "}
            <Link to="/support/purchase-restore" className="text-[#4FB3E8] underline">
              Purchase Restoration
            </Link>{" "}
            form so we can verify your receipt and restore access.
          </p>
          <h2>Account & sign-in</h2>
          <p>
            Trouble signing in? Try <Link to="/forgot-password" className="text-[#4FB3E8] underline">Reset Password</Link>.
            If your account was created with Google or Apple, use the same
            provider button on the <Link to="/login" className="text-[#4FB3E8] underline">Sign In</Link> page.
          </p>
          <h2>Bug reports & feedback</h2>
          <p>
            Please describe the problem, the device/browser you're using, and
            attach a screenshot if possible. We read every message during the
            v1.0 beta.
          </p>
          <h2>Privacy & account deletion</h2>
          <p>
            Read our <Link to="/privacy" className="text-[#4FB3E8] underline">Privacy Policy</Link>{" "}
            or delete your account from{" "}
            <Link to="/settings" className="text-[#4FB3E8] underline">Settings</Link>.
          </p>
        </>
      ) : (
        <>
          <h1>Sokongan</h1>
          <p>Sokongan kami ringkas semasa beta awam. Jika anda perlukan bantuan:</p>
          <h2>Isu pembelian</h2>
          <p>
            Jika anda telah membayar tetapi tidak nampak Full Access, sila
            gunakan borang{" "}
            <Link to="/support/purchase-restore" className="text-[#4FB3E8] underline">
              Pulihkan Pembelian
            </Link>{" "}
            supaya kami boleh sahkan resit anda dan pulihkan akses.
          </p>
          <h2>Akaun & log masuk</h2>
          <p>
            Bermasalah log masuk? Cuba <Link to="/forgot-password" className="text-[#4FB3E8] underline">Set Semula Kata Laluan</Link>.
            Jika akaun anda dicipta dengan Google atau Apple, gunakan butang
            provider yang sama di halaman <Link to="/login" className="text-[#4FB3E8] underline">Log Masuk</Link>.
          </p>
          <h2>Laporan bug & maklum balas</h2>
          <p>
            Sila terangkan masalah, peranti/pelayar yang anda gunakan, dan
            lampirkan tangkapan skrin jika boleh. Kami baca setiap mesej semasa
            beta v1.0.
          </p>
          <h2>Privasi & padam akaun</h2>
          <p>
            Baca <Link to="/privacy" className="text-[#4FB3E8] underline">Dasar Privasi</Link>{" "}
            kami atau padam akaun dari{" "}
            <Link to="/settings" className="text-[#4FB3E8] underline">Tetapan</Link>.
          </p>
        </>
      )}
    </LegalLayout>
  );
}
